import { useEffect, useRef } from 'react'
import Title from '../shared/Title'
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver'

const About = () => {
  const [aboutRef, isVisible] = useIntersectionObserver()
  const cardRefs = useRef([])

  useEffect(() => {
    const handleTilt = (e, card) => {
      const cardRect = card.getBoundingClientRect()
      const x = e.clientX - cardRect.left
      const y = e.clientY - cardRect.top
      
      const centerX = cardRect.width / 2
      const centerY = cardRect.height / 2
      
      const rotateX = (y - centerY) / 10
      const rotateY = -(x - centerX) / 10

      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`
    }

    const resetTilt = (card) => {
      card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)'
    }

    cardRefs.current.forEach(card => {
      if (card) {
        card.addEventListener('mousemove', (e) => handleTilt(e, card))
        card.addEventListener('mouseleave', () => resetTilt(card))
      }
    })

    return () => {
      cardRefs.current.forEach(card => {
        if (card) {
          card.removeEventListener('mousemove', (e) => handleTilt(e, card))
          card.removeEventListener('mouseleave', () => resetTilt(card))
        }
      })
    }
  }, [])

  const values = [
    {
      title: "Our Mission",
      description: "To foster lifelong connections among Rajagiri alumni, creating a vibrant community that supports professional growth, facilitates networking, and gives back to our alma mater. Through meaningful engagement and collaborative initiatives, we aim to preserve and strengthen the Rajagiri legacy while empowering our members to achieve their fullest potential."
    },
    {
      title: "Our Vision",
      description: "To be a dynamic and influential alumni network that serves as a bridge between past, present, and future Rajagirians. We envision a community where every alumnus feels connected, supported, and inspired to contribute to both personal and collective growth, making lasting impacts in their professional fields and society at large."
    }
  ]

  return (
    <section id="about" className="about" ref={aboutRef}>
      <div className="about__background-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
      
      <div className="container">
        <Title 
          tagline="Our Story"
          heading="About RAYS"
          subheading="The Rajagiri Association of Yesteryear Students"
          animate={isVisible}
        />
        
        <div className="about__content">
          <div className="about__image-wrapper">
            <div className="about__image">
              <img 
                src="https://picsum.photos/seed/rays-about/800/500" 
                alt="RAYS Community"
              />
              <div className="about__image-overlay"></div>
            </div>
          </div>
          
          <div className="about__text">
            <p className="glass-card">
              RAYS, the Rajagiri Association of Yesteryear Students, is more than just an alumni network—it's a vibrant community that celebrates the enduring spirit of Rajagiri. Founded with the vision of fostering lifelong connections, RAYS serves as a platform where past students can reconnect, share experiences, and contribute to the growth of both the alumni community and their alma mater.
            </p>
            
            <div className="about__values">
              {values.map((value, index) => (
                <div 
                  key={value.title}
                  ref={el => cardRefs.current[index] = el}
                  className={`value-card animate slide-up ${isVisible ? 'visible' : ''}`}
                  style={{ animationDelay: `${0.2 * (index + 1)}s` }}
                >
                  <div className="value-card__content">
                    <h3>{value.title}</h3>
                    <p>{value.description}</p>
                  </div>
                  <div className="value-card__glow"></div>
                </div>
              ))}
            </div>

            <div className={`about__highlights glass-card animate slide-up ${isVisible ? 'visible' : ''}`}>
              <h3>What Sets Us Apart</h3>
              <ul>
                <li>Strong professional network spanning diverse industries</li>
                <li>Regular events and reunions to strengthen bonds</li>
                <li>Mentorship programs for career development</li>
                <li>Collaborative initiatives with current students</li>
                <li>Community service and social impact projects</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About 